import React, { useEffect, useRef, useState } from 'react';
import img from "./404.svg";
import styles from "./Error404.module.css";
import { redirectToPage } from './common/redirects/Redirects';
import { useNavigate } from 'react-router-dom';

function Error404() {
    const navigate=useNavigate();
    const wrapperRef = useRef(null);
    const [parentHeight,setParentHeight]=useState(0);

    useEffect(() => {
        const parent = wrapperRef.current?.parentElement;
        if (parent) {
            setParentHeight(parent.getBoundingClientRect().height)
        }
    }, []);

    const backToHome = () => {
        redirectToPage(navigate,"/");
    };

    return (
        <div ref={wrapperRef} style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: parentHeight===0 ? "100vh" : parentHeight,
            width: '100%',
            backgroundColor: '#fff',
        }}>
            <div className={styles.img}>
                <img src={img} alt="404" />
            </div>
            <div className={styles.btnGrp}>
                <button className={styles.btn} onClick={backToHome}>Back To Home</button>
            </div>
        </div>
    );
}

export default Error404;
